<datalist 
  appDataList 
  id="{{appId}}" 
  appInputId="{{appInputId}}"
  appServerSearchKey="true" 
  appServerSearchValue="true" 
  appNumberTypeValueServerSearch="4"
  [appMulti]="appMulti"
  (appKeyServerSearchMethod)="searchKey($event)" 
  (appValueServerSearchMethod)="searchValue($event)" 
  (appRemoveDataListMethod)="removeDataList()" 
>
    <option *ngFor="let element of elements" value='{{preValue + element.key}}'>{{element.value}}</option>
</datalist>